import React from "react";

import userSecurityService
    from "../services/userSecurityService";

const thStyle = {

    background: "#f8f9fa",

    color: "#495057",

    fontWeight: 600,

    fontSize: "13px",

    whiteSpace: "nowrap",

    borderBottom: "2px solid #dee2e6"

};

const PermissionGrid = ({

    permissions,
    setPermissions,

    loading,
    user,
    loadPermissions

}) => {

    const handleToggle = (

        functionalityId,

        field

    ) => {

        setPermissions(

            permissions.map(permission => {

                if (

                    permission.functionality_id !== functionalityId

                ) {

                    return permission;

                }

                return {

                    ...permission,

                    [field]: !permission[field],

                    is_overridden: true,

                    source: "USER",

                    dirty: true

                };

            })

        );

    };
    const handleReset = async (

        functionalityId

    ) => {

        try {

            await userSecurityService.resetPermission(

                user.user_access_mapping_id,

                functionalityId

            );

            await loadPermissions();

        }

        catch (err) {

            console.error(err);

            alert(

                "Failed to reset permission."

            );

        }

    };
    
    return (

        <div className="card shadow-sm">

            <div className="table-responsive">

                <table className="table table-hover align-middle mb-0">

                    <thead>

                        <tr>

                            <th style={thStyle}>

                                Module

                            </th>

                            <th style={thStyle}>

                                Functionality

                            </th>

                            <th style={thStyle}>

                                Source

                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                            >

                                View

                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                            >

                                Create

                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                            >

                                Edit

                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                            >

                                Delete

                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                            >

                                Approve

                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                            >

                                Override

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            loading &&

                            <tr>

                                <td
                                    colSpan="9"
                                    className="text-center py-4"
                                >

                                    Loading...

                                </td>

                            </tr>

                        }

                        {

                            !loading &&

                            permissions.length === 0 &&

                            <tr>

                                <td
                                    colSpan="9"
                                    className="text-center py-4"
                                >

                                    No permissions found.

                                </td>

                            </tr>

                        }

                        {

                            !loading &&

                            permissions.map(permission => (

                                <tr key={permission.functionality_id}>

                                    <td>

                                        {permission.module}

                                    </td>

                                    <td>

                                        {permission.functionality_name}

                                    </td>

                                    <td>

                                        <span
                                            className={`badge ${
                                                permission.source === "USER"
                                                    ? "bg-warning text-dark"
                                                    : "bg-secondary"
                                            }`}
                                        >

                                            {permission.source}

                                        </span>

                                    </td>

                                    <td className="text-center">

                                        <div className="form-check form-switch d-flex justify-content-center">

                                            <input

                                                className="form-check-input"

                                                type="checkbox"

                                                checked={permission.can_view}

                                                onChange={() =>

                                                    handleToggle(

                                                        permission.functionality_id,

                                                        "can_view"

                                                    )

                                                }

                                            />

                                        </div>

                                    </td>

                                    <td className="text-center">

                                        <div className="form-check form-switch d-flex justify-content-center">

                                            <input

                                                className="form-check-input"

                                                type="checkbox"

                                                checked={permission.can_create}

                                                onChange={() =>

                                                    handleToggle(

                                                        permission.functionality_id,

                                                        "can_create"

                                                    )

                                                }

                                            />

                                        </div>

                                    </td>

                                    <td className="text-center">

                                        <div className="form-check form-switch d-flex justify-content-center">

                                            <input

                                                className="form-check-input"

                                                type="checkbox"

                                                checked={permission.can_edit}

                                                onChange={() =>

                                                    handleToggle(

                                                        permission.functionality_id,

                                                        "can_edit"

                                                    )

                                                }

                                            />

                                        </div>

                                    </td>

                                    <td className="text-center">

                                        <div className="form-check form-switch d-flex justify-content-center">

                                            <input

                                                className="form-check-input"

                                                type="checkbox"

                                                checked={permission.can_delete}

                                                onChange={() =>

                                                    handleToggle(

                                                        permission.functionality_id,

                                                        "can_delete"

                                                    )

                                                }

                                            />

                                        </div>

                                    </td>

                                    <td className="text-center">

                                        <div className="form-check form-switch d-flex justify-content-center">

                                            <input

                                                className="form-check-input"

                                                type="checkbox"

                                                checked={permission.can_approve}

                                                onChange={() =>

                                                    handleToggle(

                                                        permission.functionality_id,

                                                        "can_approve"

                                                    )

                                                }

                                            />

                                        </div>

                                    </td>

                                    <td className="text-center">

                                        {

                                            permission.is_overridden ? (

                                                <button

                                                    className="btn btn-sm btn-outline-danger"

                                                    title="Reset to Role Permission"

                                                    onClick={() =>

                                                        handleReset(

                                                            permission.functionality_id

                                                        )

                                                    }

                                                >

                                                    <i className="bi bi-arrow-counterclockwise"></i>

                                                </button>
                                            ) : (

                                                <span className="text-muted">

                                                    —

                                                </span>

                                            )

                                        }

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default PermissionGrid;